import { Card, Input, Form, Space } from 'antd';
import CustomerPicker2 from 'components/pickers/customer';
import AddressPicker from 'components/pickers/address';
import CollaboratorPicker from 'components/pickers/collaborator';
import Select from 'components/select';
import { useOrderEditContext } from '../OrderEditContext';

const OrderGeneralCardMobile = () => {
    const { internalStatuses, workspace, onCustomerChange, selectedCustomerID } = useOrderEditContext();

    return (
        <Card title='Thông tin chung' size='small'>
            <Space direction='vertical' size={4} style={{ width: '100%' }}>
                <Form.Item hidden name={'id'}>
                    <Input />
                </Form.Item>

                <Form.Item
                    label='Khách hàng'
                    name={['customer_id']}
                    rules={[{ required: true, message: 'Bạn phải chọn khách hàng' }]}
                >
                    <CustomerPicker2 onCustomerChange={onCustomerChange} />
                </Form.Item>

                <Form.Item
                    label='Địa chỉ giao hàng'
                    name={'shipping_address'}
                    rules={[{ required: true, message: 'Please input customer phone_number!' }]}
                >
                    <AddressPicker customer_id={selectedCustomerID} />
                </Form.Item>

                <Form.Item label='Thanh toán' name={['payment_status', 'id']}>
                    <Select
                        options={[
                            { label: 'Chờ thanh toán', value: 'unpaid' },
                            { label: 'Thanh toán 1 phần', value: 'partial' },
                            { label: 'Đã thanh toán', value: 'paid' },
                            { label: 'Chờ xác nhận thanh toán', value: 'waiting_verification' },
                        ]}
                    />
                </Form.Item>

                <Form.Item label='Vận chuyển' name={['shipping_status', 'id']}>
                    <Select
                        options={[
                            { label: 'Chờ vận chuyển', value: 'not_shipped' },
                            { label: 'Đang vận chuyển', value: 'shipping' },
                            { label: 'Đã giao', value: 'shipped' },
                        ]}
                    />
                </Form.Item>

                <Form.Item label='Trạng thái nội bộ' name={['internal_status', 'id']}>
                    <Select
                        options={internalStatuses.map((status) => ({
                            label: status.title,
                            value: status.id,
                        }))}
                    />
                </Form.Item>

                <Form.Item label='Ghi chú' name={['internal', 'note']}>
                    <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder='Nhập ghi chú nội bộ' />
                </Form.Item>

                <Form.Item label='Mã vận đơn' name={['shipping_status', 'tracking_code']}>
                    <Input placeholder='Nhập mã vận đơn' />
                </Form.Item>

                {workspace?.collaboratorSetting?.collaborator && (
                    <Form.Item label='Cộng tác viên' name={'ref_code'}>
                        <CollaboratorPicker />
                    </Form.Item>
                )}

            
            </Space>
        </Card>
    );
};

export default OrderGeneralCardMobile;
